import React from 'react'
//

export default () => (
  <div>
    <h1 style={{ textAlign: 'center' }}>Welcome to React-Static</h1>
    <img src="" alt="" style={{ display: 'block', margin: '0 auto' }} />
  </div>
)
